import { FC } from 'react';

import Breadcrumbs from 'molecules/Breadcrumbs';
import Heading from 'molecules/Heading';
import Image from 'molecules/Image';
import Section from 'molecules/Section';
import { splitSectionProps } from 'molecules/Section/config';
import VideoCustom from 'molecules/VideoCustom';

import { HeroWithImageConfigProps } from 'components/Hero/config';

interface HeroCenteredProps extends HeroWithImageConfigProps {
  includeBreadcrumbs?: boolean;
  icon?: string;
  iconV2?: {
    file?: {
      url: string;
    };
    alt?: string;
  };
  breadcrumbTitle?: string;
  mediaType?: 'image' | 'video' | 'lottie';
  videoSrc?: string;
  thumbnail?: {
    file?: {
      url: string;
    };
    alt?: string;
  };
}

const HeroCentered: FC<HeroCenteredProps> = props => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { sectionProps, rest } = splitSectionProps(props as any);
  const {
    featuredImage,
    eyebrow,
    eyebrowWords,
    heading,
    headingIcon,
    body,
    buttons,
    includeBreadcrumbs,
    icon,
    iconV2,
    breadcrumbTitle,
    mediaType = 'image',
    videoSrc,
    thumbnail,
    as,
  } = rest as HeroCenteredProps;

  const showMedia = mediaType === 'image' ? featuredImage?.file?.url : videoSrc;

  return (
    <Section {...sectionProps}>
      {includeBreadcrumbs && <Breadcrumbs breadcrumbTitle={breadcrumbTitle} />}
      <div className="flex max-w-screen-xl flex-col items-center gap-8 py-8 sm:gap-16">
        <div className="flex max-w-[800px] flex-col items-center gap-4">
          {icon && (
            <Image
              url={`data:image/png;base64, ${icon}`}
              className="flex h-full max-h-[150px] w-auto items-center justify-center rounded-lg border border-gray-700 bg-gray-700/20 p-2"
              height="50"
              width="50"
              noFill
              alt="Icon"
            />
          )}

          {iconV2 && (
            <Image
              url={iconV2?.file?.url || ''}
              alt={iconV2?.alt || 'Icon'}
              className="flex h-full max-h-[150px] w-auto items-center justify-center rounded-lg border border-gray-700 bg-gray-700/20 p-2"
              height="50"
              width="50"
              noFill
            />
          )}
          <Heading
            eyebrow={eyebrow}
            eyebrowWords={eyebrowWords}
            heading={heading}
            headingIcon={headingIcon}
            body={body}
            buttons={buttons}
            alignment="center"
            size="lg"
            as={as || 'h1'}
            animateOnMount
          />
        </div>
        {showMedia && (
          <div className="aspect-auto w-full max-w-[1080px] rounded-[27px] bg-heroFeaturedBg p-1.5 drop-shadow-heroFeaturedBoxShadow backdrop-blur-[2px] sm:p-3.5 lg:p-5">
            {mediaType === 'video' && videoSrc ? (
              <VideoCustom videoSrc={videoSrc} thumbnail={thumbnail} className="size-full" priority />
            ) : (
              <Image
                url={featuredImage?.file?.url || ''}
                alt={featuredImage?.alt || ''}
                className="size-full"
                priority
                {...featuredImage?.file}
              />
            )}
          </div>
        )}
      </div>
    </Section>
  );
};

export default HeroCentered;
